import React from "react";

export const NodeWindow = ({caption, children}) => {
  return (
    <div style={{ display: "flex", flexDirection: "row", flexFlow: "column" }}>
      {caption}
      {children}
    </div>
  )
}
